import React from 'react'
import PropTypes from 'prop-types'
import { Form, Row, Col, InputNumber } from 'antd'

const CustomTimeBounds = ({
  customTimeBoundsStart,
  customTimeBoundsEnd,
  onCustomTimeBoundsStartChange,
  onCustomTimeBoundsEndChange,
  formCss,
}) => {
  return (
    <Form.Item label="Custom start and end for time dropdown. 24 hour format. Leave either blank for defaults (8 and 18)" className={formCss.itemLabel}>
      <Row>
        <Col span={2}>
          <InputNumber
            label="Start time"
            value={customTimeBoundsStart}
            onChange={onCustomTimeBoundsStartChange}
            placeholder="Start time"
            min={0}
            max={22}
          />
        </Col>
        <Col span={2}>
          <InputNumber
            label="End time"
            value={customTimeBoundsEnd}
            onChange={onCustomTimeBoundsEndChange}
            placeholder="End time"
            min={customTimeBoundsStart ? customTimeBoundsStart + 1 : 9}
            max={23}
          />
        </Col>
      </Row>
    </Form.Item>
  )
}

CustomTimeBounds.propTypes = {
  customTimeBoundsStart: PropTypes.number,
  customTimeBoundsEnd: PropTypes.number,
  onCustomTimeBoundsStartChange: PropTypes.func.isRequired,
  onCustomTimeBoundsEndChange: PropTypes.func.isRequired,
  css: PropTypes.object.isRequired,
  formCss: PropTypes.object.isRequired,
}

export default CustomTimeBounds



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/CustomTimeBounds.js